import { getCurrencyFormat } from '../utils/utils'
import NumberParser from '../leasing-calculator/NumberParser'
import leasingData from './leasing-data'
import { evaluateFormula } from './evaluateFormula'

let calculationPerformed = false

export function updateCalculation (
  leasingData,
  leasingRuntimeDropdown,
  leasingMoneyInput,
  leasingResult
) {
  const locale = leasingData.getLocale()
  const currency = leasingData.getCurrency()

  // get product and Asset information
  const productKey = document.querySelector('#product-select')?.value
  const assetName = document.querySelector('#asset-select')?.value
  const asset = leasingData.getAsset(productKey, assetName)
  const formula = leasingData.getFormula(productKey, assetName)

  if (!asset) return

  const monthsAndFactors = asset.monthsAndFactors
  const valuesArray = asset.values
  const runtimeValue = leasingRuntimeDropdown.value
  const factorsArray = monthsAndFactors?.[runtimeValue]

  if (!factorsArray || !valuesArray || valuesArray.length < 2 || factorsArray.length < 1) return

  // Wert aus Inputfeld holen
  const cleanedMoneyValue = leasingMoneyInput.value.match(/\d|[,.]/g)?.join('') || ''
  const moneyValue = new NumberParser(locale).parse(cleanedMoneyValue) || 0

  // Hauptlogik für Wertebereich
  for (let i = 0; i < valuesArray.length - 1; i++) {
    const lowerBound = valuesArray[i]
    const upperBound = valuesArray[i + 1]

    if (moneyValue >= lowerBound && moneyValue < upperBound) {
      const factor = factorsArray[i]
      const result = calculateResult(moneyValue, factor, formula)
      updateResultDisplay(leasingResult, result, currency, locale)
      return
    }
  }

  // Wenn der Wert über dem höchsten Range liegt, letzten gültigen Faktor nehmen
  if (moneyValue > valuesArray[valuesArray.length - 1]) {
    const lastNonZeroFactor = [...factorsArray].reverse().find(factor => factor !== 0)
    if (lastNonZeroFactor) {
      const result = calculateResult(moneyValue, lastNonZeroFactor, formula)
      updateResultDisplay(leasingResult, result, currency, locale)
    } else {
      updateResultDisplay(leasingResult, null, currency, locale)
    }
  } else {
    leasingResult.textContent = ''
  }
}

function calculateResult (moneyValue, factor, formula) {
  //return (moneyValue * factor) / 100;
  const variables = { 'VAL': moneyValue, 'FAC': factor }
  return evaluateFormula(formula, variables).toFixed(2)
}

function updateResultDisplay (leasingResult, result, currency, locale) {
  if (result !== null && result !== undefined && leasingData.getShowRate()) {
    leasingResult.textContent = `${getCurrencyFormat(locale, currency, result)}`
  } else {
    leasingResult.textContent = ''
  }
  calculationPerformed = true
}

export function wasCalculationPerformed () {
  return calculationPerformed
}
